import { donationsApi } from '../api/donationsApi'
import type { DonationUpdateInput } from '../types/donation'

export const verifyDonation = async (donation: DonationUpdateInput) => {
  try {
    const { data } = await donationsApi.verifyDonation(donation)
    return data
  } catch (error) {
    console.error(`Error verifying donations: `, error)
    throw error
  }
}
